<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="举报人" prop="nickname" >
        <a-input readOnly v-model="form.nickname" placeholder="请输入用户ID｛user.id｝" />
      </a-form-model-item>
      <a-form-model-item label="音频" prop="musicUrl" >
        <audio :src="form.musicUrl" :autoplay="false"
               controls="controls"/>
      </a-form-model-item>
      <a-form-model-item label="状态" prop="status" >
        <a-radio-group v-model="form.status">
          <a-radio :value="0">待审核</a-radio>
          <a-radio :value="1">通过</a-radio>
          <a-radio :value="2">驳回</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="举报原因" prop="content" v-if="form.status == 2">
        <editor v-model="form.content" />
      </a-form-model-item>
      <a-form-model-item label="驳回原因" prop="rejectReason" >
        <a-input v-model="form.rejectReason" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getReport, addReport, updateReport } from '@/api/music/report'
import Editor from '@/components/Editor'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    Editor
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        userId: null,
        nickname: null,
        musicUrl: null,
        musicId: null,

        status: 0,

        content: null,

        rejectReason: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        userId: [
          { required: true, message: '用户ID｛user.id｝不能为空', trigger: 'blur' }
        ],
        musicId: [
          { required: true, message: '音频ID｛music.id｝不能为空', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '状态 0-待审核 1-通过 2-驳回不能为空', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '举报原因不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        nickname: null,
        musicUrl: null,
        musicId: null,
        status: 0,
        content: null,
        rejectReason: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getReport({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '审核'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateReport(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addReport(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
